import { listLanguage } from '../../configs/LanguageConfig';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../app/commonReducer';
import { VNINDEX } from '../common/Const';
import { get } from 'lodash';
import { TYPE_BLUE, TYPE_DISABLE } from '../common/sync-component/Const';
// import { ALERT_LOCAL_STORAGE_KEY } from '../main-layout/header/right/alerts/AlertSubscriber';
// import { NOTIFICATION_SUBSCRIBED_KEY } from '../main-layout/sidebar/reducer';
import { CHARTING_LOCAL_STORAGE_KEY } from '../technical/charting/trading-view/TradingView';
import CurrentState from './CurrentState';
import { KEY_LANGUAGE } from './Language';
import { convertStringToFloat } from './Text';
import { includes } from 'lodash';
import ConstCommon from '../common/Const';
import {
  CURRENT_STATE_KEY,
  minSizeComponent,
  nameSaveStateDefault,
  resolution,
} from '../../configs/LayoutConfig';
import moment from 'moment';
import store from '../app/store.js';
import { create, all } from 'mathjs';
const SYNC_COMPONENT_STATE_KEY = 'SYNC_COMPONENT_STATE_KEY';
const SYNC_COMPONENT_SEARCH_KEY = 'SYNC_COMPONENT_SEARCH_KEY';

export {
  getNormDist,
  getCodeData,
  getCodeFromQuery,
  getQueryParams,
  getStandardDeviation,
  uniqueNumber,
  getDataFollowKeyByDot,
  setDataFollowKeyByDot,
  getItemMinInList,
  searchTextInListByListKey,
  searchTextInListIcbByListKey,
  searchTextInListByKey,
  searchTextInListIcbByKey,
  compareSortArrayObjectByString,
  isTicker,
  formatComGroupCode,
  getMinSizeComponent,
  checkIsBank,
  getUnique,
  removeDragCode,
  formatDataBidAsk,
  checkIsInsurance,
  removeSpecialChar,
  getNewsUrl,
  getCurrentDate,
  isOpenSpecificComponent,
  getSMA,
  getRanking,
  saveSyncComponentState,
  getSyncComponentState,
  syncComponentSelector,
  getDefaultSyncType,
  tradingTimeInterval,
  getSyncComponentSearch,
  setSyncComponentSearch,
  getSyncDefaultSearch,
  saveLastComponentSyncType,
  getLastComponentSyncType,
  getParamFromSortState,
  getDefaultIfEmpty,
  isNotLoginOrExpired,
  isNotLogin,
  isExpired,
  isBetweenTime,
  isBetweenTradingTime,
  clearLocalStorage,
  removeAccents,
};

export const ATO = 'ATO';
export const ATC = 'ATC';

function clearLocalStorage() {
  localStorage.removeItem(CHARTING_LOCAL_STORAGE_KEY);
  localStorage.removeItem(nameSaveStateDefault);
  //localStorage.removeItem(ALERT_LOCAL_STORAGE_KEY);
  localStorage.removeItem(KEY_LANGUAGE);
  localStorage.removeItem(CURRENT_STATE_KEY);
  //localStorage.removeItem(NOTIFICATION_SUBSCRIBED_KEY);
}

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

function isNotLogin(user) {
  return !user || !Object.keys(user).length;
}

function isExpired(user) {
  const now = moment().startOf('day');
  const endDate = moment(user.profile.end_date, 'DD/MM/YYYY');

  return now > endDate;
}

function isNotLoginOrExpired(user) {
  return isNotLogin(user) || isExpired(user);
}

function getDefaultIfEmpty(obj, defaultObj) {
  if (!Object.keys(obj).length) {
    return defaultObj;
  }

  return obj;
}

function getParamFromSortState(sortState, mergeObj = {}) {
  try {
    const mapKey = {
      ticker: 'Ticker',
      rank: 'RankValue',
      size: 'RankFirmSize',
      profit: 'RankProfitAdded',
      cashflow: 'RankCfo',
      valuation: 'RankValuation',
      trading: 'RankTrading',
      analysisCover: 'RankAnalystCover',
      rtd11: 'Rtd11',
      ranking: 'IcbRank',
      value: 'Value',
      growth: 'Growth',
      momentum: 'Momentum',
      vgm: 'Vgm',
      total: 'Total',
      currentEarning: 'CurrentEarning',
      annualEarning: 'AnnualEarning',
      newProduct: 'NewProduct',
      supplyDemand: 'SupplyDemand',
      leaderorLagard: 'LeaderorLagard',
      institutionalSponsorship: 'InstitutionalSponsorship',
      marketDirection: 'MarketDirection',
      totalMatchVolume: 'TotalMatchVolume',
      returnDownTrend: 'ReturnDownTrend',
      matchPrice: 'MatchPrice',
      rsi14: 'Rsi14',
      ma20: 'Ma20',
      previousPrice: 'PreviousPrice',
      previousVolume: 'PreviousVolume',
      averagePrice2Week: 'AveragePrice2Week',
      averageMatchVolume2Week: 'AverageMatchVolume2Week',
      icbRank: 'IcbRank',

      averageMatchVolume1Month: 'AverageMatchVolume1Month',
      topPrevious: 'TopPrevious',
      rtd21: 'Rtd21',
      rtd25: 'Rtd25',

      ma5: 'Ma5',
      ma50: 'Ma50',
      ma100: 'Ma100',
      ma200: 'Ma200',
    };

    const [key] = Object.keys(sortState);

    return {
      order: sortState[key],
      orderBy: mergeObj[key] || mapKey[key] || capitalizeFirstLetter(key),
    };
  } catch (e) {
    return {};
  }
}

function formatComGroupCode(code) {
  const map = {
    VNINDEX: 'HOSE',
    HNXIndex: 'HNX',
    UpcomIndex: 'UPCOM',
    VN30: 'HOSE',
    HNX30: 'HNX',
  };
  return map[code] || code;
}

function checkIsBank(comTypeCode) {
  return comTypeCode === 'NH';
}

function checkIsInsurance(comTypeCode) {
  return comTypeCode === 'BH';
}

function getDataFollowKeyByDot(data, strKey) {
  if (!data) {
    return '--';
  } // check if data === null or undefined
  let result = data;
  const listKey = strKey != null ? strKey.split('.') : [];
  listKey.forEach(value => {
    if (includes([undefined, null], result[value])) {
      result = '--';
      return;
    }
    result = result[value];
  });

  return result;
}

function setDataFollowKeyByDot(data, strKey, value) {
  var listKey = strKey.split('.');
  while (listKey.length - 1) {
    var n = listKey.shift();
    if (!(n in data)) data[n] = {};
    data = data[n];
  }
  data[listKey[0]] = value;
}

function removeAccents(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .trim();
}

function searchTextInListIcbByKey(list, text, key) {
  const noStartResult = [];
  const startResult = [];
  const remain = [];
  text = removeAccents(text);

  list = typeof list === 'undefined' ? [] : list;
  list.forEach(item => {
    const data = key ? item[key] : item;

    if (data) {
      if (removeAccents(data.toLowerCase()).indexOf(text.toLowerCase()) === 0) {
        startResult.push(item);
      } else if (
        removeAccents(data.toLowerCase()).indexOf(text.toLowerCase()) !== -1
      ) {
        noStartResult.push(item);
      } else {
        remain.push(item);
      }
    } else {
      remain.push(item);
    }
  });

  return {
    result: startResult.concat(noStartResult),
    remain,
  };
}

function searchTextInListByKey(list, text, key, isSort = true) {
  const noStartResult = [];
  const startResult = [];
  const remain = [];
  text = removeAccents(text);
  list = typeof list === 'undefined' ? [] : list;
  list.forEach(item => {
    const data = key ? item[key] : item;

    if (data) {
      if (removeAccents(data.toLowerCase()).indexOf(text.toLowerCase()) === 0) {
        startResult.push(item);
      } else if (
        removeAccents(data.toLowerCase()).indexOf(text.toLowerCase()) !== -1
      ) {
        noStartResult.push(item);
      } else {
        remain.push(item);
      }
    } else {
      remain.push(item);
    }
  });

  if (key && isSort) {
    startResult.sort((a, b) => compareSortArrayObjectByString(a, b, key));
    noStartResult.sort((a, b) => compareSortArrayObjectByString(a, b, key));
  }

  return {
    result: startResult.concat(noStartResult),
    remain,
  };
}

function searchTextInListIcbByListKey(list, text, listKey) {
  if (listKey) {
    const result = [];

    listKey.forEach(key => {
      const { result: listByKey, remain } = searchTextInListIcbByKey(
        list,
        text,
        key,
      );
      list = remain;
      result.push(...listByKey);
    });
    return { result, remain: list };
  }

  return searchTextInListIcbByKey(list, text);
}

function searchTextInListByListKey(list, text, listKey, isSort) {
  if (listKey) {
    const result = [];

    listKey.forEach(key => {
      const { result: listByKey, remain } = searchTextInListByKey(
        list,
        text,
        key,
        isSort,
      );
      list = remain;
      result.push(...listByKey);
    });
    return { result, remain: list };
  }

  return searchTextInListByKey(list, text);
}

function getItemMinInList(list, listIgnore = []) {
  let min = list.length > 0 ? list[0] : '--';

  list.forEach(item => {
    if (!includes(listIgnore, item)) {
      if (typeof item === 'number') {
        min = Math.min(min, item);
      }
      if (typeof item === 'string') {
        min = Math.min(convertStringToFloat(min), convertStringToFloat(item));
      }
    }
  });

  return min;
}

export const fontSizeFitWidth = ({
  width,
  height,
  max = 32,
  min = 8,
  mainText,
  subText,
  padding = 4,
}) => {
  const div = document.createElement('div');
  const mainTextEl = document.createElement('div');
  mainTextEl.innerText = mainText;
  const subTextEl = document.createElement('div');
  subTextEl.innerText = subText;
  subTextEl.style.fontSize = '0.75em';
  div.appendChild(mainTextEl);
  div.appendChild(subTextEl);
  div.style.position = 'absolute';
  div.style.left = '9999px';
  div.style.top = '9999px';
  div.style.padding = `${padding}px`;
  div.style.whiteSpace = 'nowrap';
  document.body.appendChild(div);
  let fontSize = max;
  while (fontSize > min) {
    div.style.fontSize = `${fontSize}px`;
    if (width > div.clientWidth && height > div.clientHeight) {
      break;
    }

    fontSize *= 0.54;
  }
  document.body.removeChild(div);
  return fontSize > min ? fontSize : 0;
};

function compareSortArrayObjectByString(a, b, key) {
  if (a[key] < b[key]) {
    return -1;
  }
  if (a[key] > b[key]) {
    return 1;
  }
  return 0;
}

function isTicker(indexSummary) {
  return indexSummary && indexSummary.floorPrice && indexSummary.ceilingPrice;
}

function getMinSizeComponent() {
  if (window.innerWidth <= resolution.MIN_SIZE) {
    return minSizeComponent.MIN_SIZE;
  }
  if (window.innerWidth <= resolution.SMALL_SIZE) {
    return minSizeComponent.SMALL_SIZE;
  }
  if (window.innerWidth <= resolution.MEDIUM_SIZE) {
    return minSizeComponent.MEDIUM_SIZE;
  }
  if (window.innerWidth <= resolution.MAX_SIZE) {
    return minSizeComponent.MAX_SIZE;
  }
}

function getUnique() {
  return new Date().getTime();
}

function uniqueNumber(max = 10000) {
  return Math.floor(Math.random() * max);
}

function removeDragCode(glContainer) {
  const { props } = glContainer.parent.config;
  if (!props) {
    return;
  }
  const { dragCode: _, ...rest } = props;
  glContainer.parent.config.props = rest;
}

function isInRange(value, range) {
  const timeValue = moment(`${value}`, 'hh:mm:ss');
  const timeStart = moment(`${range[0]}`, 'hh:mm:ss');
  const timeEnd = moment(`${range[1]}`, 'hh:mm:ss');

  return timeValue.isAfter(timeStart) && timeValue.isBefore(timeEnd);
}

function formatTime(time) {
  return `${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
}

function formatDataBidAsk(
  bidAsk,
  bidAskVolume,
  isDerivative = false,
  marketStatus = '',
  comGroupCode = '',
) {
  if (comGroupCode !== VNINDEX || isDerivative) {
    if (marketStatus === ATO) {
      return ATO;
    }

    if (marketStatus === ATC) {
      return ATC;
    }

    return null;
  }

  const rangeMorning = isDerivative
    ? ['8:45:00', '9:00:00']
    : ['9:00:00', '9:15:00'];
  const rangeAfternoon = ['14:30:00', '14:45:00'];
  const timeOffset = store.getState()['COMMON:'].timeOffset || 0;
  const now = new Date();
  now.setSeconds(now.getSeconds() + timeOffset);
  const formatedTime = formatTime(now);
  if (bidAsk === 0) {
    if (bidAskVolume > 0) {
      if (isInRange(formatedTime, rangeMorning)) {
        return ATO;
      } else if (isInRange(formatedTime, rangeAfternoon)) {
        return ATC;
      }
    } else {
      return '--';
    }
  }
  return false; // false redirect execute
}

function removeSpecialChar(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');

  return str;
}

function getNewsUrl(locale, newsId) {
  const prefix =
    locale === listLanguage.en
      ? 'https://web.fiintrade.vn/en/news?id='
      : 'https://web.fiintrade.vn/tin?id=';

  return `${prefix}${newsId}`;
}

function getCurrentDate() {
  return moment().format('YYYYMMDD');
}

function isOpenSpecificComponent() {
  const paramsString = window.location.hash.replace('#', '');
  if (!paramsString) {
    return false;
  }
  const params = new URLSearchParams(paramsString);
  const component = params.get('c');

  return ConstCommon.listComponent[component];
}

function getSMA(sma, price) {
  if (price === 0) {
    return '--';
  }

  if (sma > price) {
    return 'bearish';
  }

  if (sma < price) {
    return 'bullish';
  }

  return 'neutral';
}

function getRanking(rank, total) {
  if (rank === 0 && total === 0) {
    return 'N/A';
  }

  return `${rank}/${total}`;
}

function saveLastComponentSyncType(componentName, type) {
  CurrentState.add(ConstCommon.listComponent.Sync, componentName, type);
}

function getLastComponentSyncType(componentName) {
  return CurrentState.get(ConstCommon.listComponent.Sync, componentName) || '';
}

function saveSyncComponentState(data) {
  CurrentState.add(
    ConstCommon.listComponent.Sync,
    SYNC_COMPONENT_STATE_KEY,
    data,
  );
}

function getSyncComponentState() {
  return (
    CurrentState.get(
      ConstCommon.listComponent.Sync,
      SYNC_COMPONENT_STATE_KEY,
    ) || {}
  );
}

function getSyncComponentSearch() {
  return (
    CurrentState.get(
      ConstCommon.listComponent.Sync,
      SYNC_COMPONENT_SEARCH_KEY,
    ) || {}
  );
}

function setSyncComponentSearch(data) {
  return CurrentState.add(
    ConstCommon.listComponent.Sync,
    SYNC_COMPONENT_SEARCH_KEY,
    data,
  );
}

function getDefaultSyncType(componentName) {
  const lastSyncType = getLastComponentSyncType(componentName);
  if (lastSyncType) {
    return lastSyncType;
  }

  return TYPE_BLUE;
}

function syncComponentSelector(state, componentName, componentId) {
  try {
    return get(
      state,
      [COMMON_REDUCER_NAME, 'syncComponent', componentName, componentId],
      getDefaultSyncType(componentName),
    );
  } catch (e) {
    return TYPE_DISABLE;
  }
}

function getSyncDefaultSearch(componentName, tickerOnly = false) {
  const syncComponentSearch = getSyncComponentSearch();
  const organization = syncComponentSearch[getDefaultSyncType(componentName)];
  if (tickerOnly) {
    return organization && organization.isTicker ? organization : null;
  }

  return organization;
}

function isBetweenTime(value, range) {
  const [start, end] = range;
  const timeValue = moment(value, 'hh:mm:ss');
  const timeStart = moment(start, 'hh:mm:ss');
  const timeEnd = moment(end, 'hh:mm:ss');
  return timeValue.isAfter(timeStart) && timeValue.isBefore(timeEnd);
}

function isBetweenTradingTime() {
  const morningWorkTime = ['08:45:00', '11:35:00'];
  const afternoonWorkTime = ['13:00:00', '15:05:00'];
  const now = new Date();

  return (
    isBetweenTime(now, morningWorkTime) || isBetweenTime(now, afternoonWorkTime)
  );
}

function tradingTimeInterval(func, intervalValue = 30 * 1000) {
  if (!isBetweenTradingTime()) {
    return null;
  }

  return setInterval(() => {
    if (!isBetweenTradingTime()) {
      return;
    }

    func();
  }, intervalValue);
}

function getQueryParams(key) {
  const urlSearchParams = new URLSearchParams(window.location.search);

  return urlSearchParams.get(key);
}

function getCodeData(accepts) {
  let data = {};
  accepts.forEach(type => {
    if (type === 'stock') {
      const organizationObj = store.getState()[COMMON_REDUCER_NAME]
        .listOrganizationByTicker;
      data = {
        ...data,
        ...organizationObj,
      };
    }
    if (type === 'index') {
      const indexObj = store.getState()[COMMON_REDUCER_NAME]
        .listCompanyGroupByComGroupCode;
      data = {
        ...data,
        ...indexObj,
      };
    }
    if (type === 'derivative') {
      const listDerivativeByDerivativeCode = store.getState()[
        COMMON_REDUCER_NAME
      ].listDerivativeByDerivativeCode;
      data = {
        ...data,
        ...listDerivativeByDerivativeCode,
      };
    }
  });

  return data;
}

function getCodeFromQuery(accepts = ['stock', 'index']) {
  const stringCode = getQueryParams('code');
  if (!stringCode) {
    return undefined;
  }
  const data = getCodeData(accepts);

  return data[stringCode];
}

function getStandardDeviation(values) {
  if (!Array.isArray(values) && values.length <= 1) {
    return 0;
  }
  //https://www.wikihow.vn/T%C3%ADnh-%C4%90%E1%BB%99-l%E1%BB%87ch-Chu%E1%BA%A9n
  const total = values.reduce((t, num) => t + num, 0);
  const avg = total / values.length;
  const mean = values.reduce((total, num) => total + Math.pow(num - avg, 2), 0);
  const variance = mean / (values.length - 1);

  return Math.sqrt(variance);
}

function getNormDist(values) {
  const math = create(all, {});
  const cumulative = math.erf(values / math.sqrt(2)) / 2;
  return cumulative + 0.5;
}
